export default {
  setCategories(state, categories) {
    state.categories = categories;
  },
  setTopics(state, topics) {
    state.topics = topics;
  },
  setTags(state, tags) {
    state.tags = tags;
  },
  setBestUsers(state, bestUsers) {
    state.bestUsers = bestUsers;
  },
  setTopic(state, topic) {
    state.topic = topic;
  },
  setComments(state, comments) {
    state.comments = comments;
  },
  setCount(state, count) {
    state.count = count;
  }
};
